<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div>
    <header class="bar bar-nav">
      <button class="share-link" v-if="hasSharePermission" :disabled="!hasLogin || totalPrice <= 0" @click="shareBuyCartContent()">生成分享链接</button>
      <h1 class='title' style="font-weight: bold;color: #00469A; ">我的购物车({{getTotalGoodsNum}})</h1>
    </header>
    <div class="content pull-to-refresh-content" data-ptr-distance="55">
      <div class="pull-to-refresh-layer">
        <div class="preloader"></div>
        <div class="pull-to-refresh-arrow"></div>
      </div>
      <div>
        <div class="content-block-title" v-if="!hasLogin">
          <span class="button button-round" @click="$router.push({name: 'login'})">点此登录以同步手机端和电脑端购物车</span>
        </div>
        <div class="list-block media-list" style="overflow-x: hidden;padding-bottom: 2rem" >
          <ul style="margin-bottom: 6rem">
            <li v-for="product in products" style="margin-right: .8rem">
              <div class="item-content">
              <label class="label-checkbox ">
                <input type="checkbox" name="my-checkbox" v-on:click="getChecked(product)" v-model="product.isChecked">
                <div class="item-media"><i class="icon icon-form-checkbox"></i></div>
              </label>
                <div class="item-inner" style="padding-bottom: 0rem;border-bottom: 0px solid " @click="goToDetail(product)">
                  <div class='color-danger' v-if="product.availableFlag === 0">商品已下架</div>
                  <div class="item-title-row">
                    <span v-if="filteredShowPromotions(product) && filteredShowPromotions(product).length > 0">
                        <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{filteredShowPromotions(product)[0].name}}</span>
                   </span>
                  </div>
                  <div class="item-title">
                    <span v-if="product.categoryId !== emkt.PRODUCT_TYPE_SERVICE_CONSTANT">
                      <span v-for="title in product._titleList" style="margin-right: .3rem"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span>
                    </span>
                    <span v-else>
                      <span>{{product.product}}</span>
                    </span>
                  </div>
                  <div class="item-subtitle" style="font-size: xx-small">
                    <label class="label-checkbox checkbox-el " v-for="abstract in product._abstractList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem" v-if="abstract.valueText !== '-1' "><span v-if="abstract.columnName === 'TVInfo' && abstract.valueText.TLNo !== undefined">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></div></div>
                    </label>
                    <label class="label-checkbox checkbox-el " v-for="subTitle in product._subTitleList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem">{{subTitle.valueText}}</div></div>
                    </label>
                  </div>
                  <div class="item-text" ><div style="height: 1.6rem">
                    <div style="float:left;"> <span style="font-size: x-small;color: #1482E7" v-if="product.selfOperated === 0">【代购】</span>
                    <span style="margin-left: .3rem"><button class="button workdays" >周期{{product.cycle}}个工作日</button></span></div>
                    <div style="float: right;font-size: .5rem">
                      <span class="sub-span" v-if="product.stockOrCustomized === 0">现货</span>
                      <span class="sub-span" v-if="product.stockOrCustomized === 1">定制</span>
                    </div>
                  </div></div>
                </div>
              </div>
              <div class="item-media" style="margin-left: 13%;height: 50px;border-bottom: 1px solid #e7e7e7;">
                <div class="item-media" style="width: 38%;color: #00469A">
                  <span style="font-size: x-small">￥</span>
                  <span v-if="showSecPromotionInfo(product)">
                    <span v-if="secPromotionType(product)===1" style="font-size: larger; color: #ff0000">{{secPromotionPrice(product)}} </span>
                    <img style="display: inline-block" src="/emktResources/resocurces/img/promotion/miaosha_mobile.png" alt="秒杀进行" width="15px">
                  </span>
                  <span v-else>
                    <span style="font-size: larger"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">{{product.priceMax && product.priceMax.toFixed(2)}}</span>
                    <span style="font-size: larger"  v-else-if="product.categoryId!==emkt.PRODUCT_TYPE_SERVICE_CONSTANT">{{product.priceMin && product.priceMin.toFixed(2)}}</span>
                    <span style="font-size: larger"  v-else>{{product.standardPrice && product.standardPrice.toFixed(2)}}</span>
                  </span>
                </div>
                <div class="item-media"  style="width: 38%" v-if="product.categoryId == 7">
                  <a href="javascript:void 0" @click="changeQuantity(product,-1)" style="margin-right: 5px;">-</a>
                  <input type="text" :value = "product.productQuantity" disabled
                         style="width: 25px;height: 30px;padding: 0;text-align: center;border:1px solid #e9e9e9 ;color: #00469A">
                  <a href="javascript:void 0" @click="changeQuantity(product,1)" style="margin-left: 5px;">+</a>
                </div>
                <div class="item-media"  style="width: 38%" v-if="product.categoryId == 10 && QuoteStatus === false">
                  <router-link :to="{name: 'custOrder', query: {cust: product}}" style="margin-right: 5px;">修改</router-link>
                </div>
                <div class="item-media"  style="width: 38%" v-else-if="product.categoryId == 10 && QuoteStatus === true">
                  <span style="margin-right: 5px;color: gray" class="gotopay_button_style">修改</span>
                </div>
                <div class="item-media"  style="width: 35%">
                  <div class="item-input">
                    <a class="item-media" v-on:click="removeProduct(product,product.merchandiseId)">
                      <div class="item-media"><span class="icon icon-remove"></span></div>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--<div class="list-block media-list" style="margin-top: -10px;overflow-x: hidden;">-->
        <!--<ul>-->
          <!--<li style="border-bottom: .1rem solid #e9e9e9;border-top: .1rem solid #e9e9e9;" v-for="(product,index) in products">-->


            <!--<div class="item-content">-->
              <!--<label class="label-checkbox" style="margin-right: 8%;">-->
                <!--<input type="checkbox" name="my-checkbox" v-on:click="getChecked(product)"-->
                       <!--v-model="product.isChecked">-->
                <!--<div class="item-media">-->
                  <!--<i class="icon icon-form-checkbox">-->
                  <!--</i>-->
                <!--</div>-->
              <!--</label>-->

              <!--<div class="item-inner" style="border-bottom: 1px solid #e7e7e7;">-->
                  <!--&lt;!&ndash;<div class="item-media"><img :src="baseurl + product.merchandiseIcon" style='width: 4rem;'></div>&ndash;&gt;-->
                  <!--&lt;!&ndash;<div class="item-inner" style="border-bottom: none">&ndash;&gt;-->
                    <!--&lt;!&ndash;<div class="item-title-row">&ndash;&gt;-->
                      <!--&lt;!&ndash;<div v-if="product.merchandiseLabel">{{ product.merchandiseLabel }}</div>&ndash;&gt;-->
                      <!--&lt;!&ndash;&lt;!&ndash;<div v-else-if="product.0.ProductName">{{ product.0.ProductName }}</div>&ndash;&gt;&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->

                    <!--&lt;!&ndash;<div style="margin-top: 5px;">&ndash;&gt;-->
                      <!--&lt;!&ndash;<div >&ndash;&gt;-->
                          <!--&lt;!&ndash;<span>&ndash;&gt;-->
                            <!--&lt;!&ndash;<span style="font-size: xx-small;margin-left: 4px" v-for="attr in product.attrs" > {{attr.key}}:{{attr.value}}</span>&ndash;&gt;-->
                          <!--&lt;!&ndash;</span>&ndash;&gt;-->
                      <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;<div class="item-subtitle" style="color: #0894ec">&ndash;&gt;-->
                      <!--&lt;!&ndash;<div class="item-title-row" v-if="product.bpromotions && product.bpromotions.length>0" >&ndash;&gt;-->
                        <!--&lt;!&ndash;<div v-if="product.bpromotions[0].type !== 0">&ndash;&gt;-->
                          <!--&lt;!&ndash;<span>&ndash;&gt;-->
                            <!--&lt;!&ndash;<span style="color: #f00b0d;font-size: x-small;border: thin solid red "  > {{product.bpromotions[0].typeName}}</span>&ndash;&gt;-->
                            <!--&lt;!&ndash;<span style="color: #f00b0d;font-size: xx-small">{{product.bpromotions[0].name}}</span>&ndash;&gt;-->
                          <!--&lt;!&ndash;</span>&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                      <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->

                    <!--&lt;!&ndash;<div class="badge" v-for="tag in product.tags" style="margin-left: 5px">&ndash;&gt;-->
                    <!--&lt;!&ndash;<span>{{tag}}</span>&ndash;&gt;-->
                   <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--<a @click="goToDetail(product)" class="item-link">-->
                  <!--<div style= "margin-top: 1rem">-->
                    <!--<span v-if="product.showpromotion.length > 0 " style="font-size: xx-small;color: red">参与活动：{{product.showpromotion[0].name}}...</span>-->
                    <!--<div style="border: #00469A; padding-bottom: .5rem">-->
                      <!--<span v-if="product._subTitleList && product._subTitleList.length > 0 " v-for="subTitle in product._subTitleList">-->
                        <!--<span style="position:relative;color: white;background-color: white; padding: 0.1rem;"></span>-->
                        <!--<span style="font-size: 0.7rem;color: white;background-color: #00469A;padding: 0.1rem;">{{subTitle.valueText}}</span>-->
                      <!--</span>-->

                     <!--<span style="font-size: 0.9rem;color: black;" v-if="product._abstractList && product._abstractList.length>0"-->
                           <!--v-for="abstract in product._abstractList">-->
                        <!--{{abstract.valueText}}</span>-->
                    <!--</div>-->

                    <!--<span style="left:0; bottom:0;font-size: 1.2rem;color: #3F3F3F;padding:0.2rem 0 0.2rem 0;font-weight: bold"-->
                          <!--v-if="product._titleList && product._titleList.length > 0" v-for="title in product._titleList">-->
                      <!--<span v-if="title.valueText !== '-1'">{{title.valueText}}</span>-->
                    <!--</span>-->
                    <!--&lt;!&ndash;<merchdata :merchList="merchList" :description="description"></merchdata>&ndash;&gt;-->
                  <!--</div>-->
                  <!--<div v-if="product.selfOperated === 0">-->
                    <!--<span style="font-size: x-small;color: #1482E7">【第三方】</span>-->
                  <!--</div>-->
                <!--</a>-->
                    <!--&lt;!&ndash;<div class="item-title" style="color: #d94b73">{{product.price*product.productQuantity | currencyStyle}}</div>&ndash;&gt;-->
              <!--</div>-->

            <!--</div>-->
            <!--<div class="item-media" style="margin-left: 13%;height: 60px;">-->
              <!--<div class="item-media" style="width: 38%;color: #00469A">-->

                <!--<span style="font-size: x-small">￥</span>-->
                <!--<span style="font-size: larger"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">{{product.priceMax}}</span>-->
               <!--<span style="font-size: larger"  v-else>{{product.priceMin}}</span></div>-->
            <!--<div class="item-media"  style="width: 38%" v-if="product.categoryId != 10">-->
                <!--<a href="javascript:void 0" @click="changeQuantity(product,-1)" style="margin-right: 5px;">-</a>-->
                <!--<input type="text" :value = "product.productQuantity" disabled-->
                       <!--style="width: 25px;height: 30px;padding: 0;text-align: center;border:1px solid #e9e9e9 ;color: #00469A">-->
                <!--<a href="javascript:void 0" @click="changeQuantity(product,1)" style="margin-left: 5px;">+</a>-->
              <!--</div>-->
              <!--<div class="item-media"  style="width: 38%" v-if="product.categoryId == 10 && QuoteStatus === false">-->
                <!--<router-link :to="{name: 'custOrder', query: {cust: product}}" style="margin-right: 5px;">修改</router-link>-->
              <!--</div>-->
              <!--<div class="item-media"  style="width: 38%" v-else-if="product.categoryId == 10 && QuoteStatus === true">-->
                <!--<span style="margin-right: 5px;color: gray" class="gotopay_button_style">修改</span>-->
              <!--</div>-->
              <!--<div class="item-media"  style="width: 35%">-->
              <!--<div class="item-input">-->
                <!--<a class="item-media" v-on:click="removeProduct(product.merchandiseId)">-->
                  <!--<div class="item-media"><span class="icon icon-remove"></span></div>-->
                <!--</a>-->
              <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
      <!--<merchdata :merchList="recomPproducts" :description="description"></merchdata>-->

    </div>
    <footer class="bar bar-footer-secondary" style="height: 3rem;margin: 0 auto;">
      <div style="height:100%; padding:3%">
        <label class="label-checkbox item-content" style="width: 50%;">
          <input type="checkbox" name="my-checkbox" v-on:click="checkedAll" v-model="isCheckedAll">
          <div class="item-media"><i class="icon icon-form-checkbox"></i><span style="margin-left: 0.3rem">合计:</span>

            <span style="margin-left: 0.7rem"><span style="font-size: x-small">￥</span>
              <span v-if="secPromotionProductIncluded()" style="color: #ff0000;font-weight: bold;font-size: large;">
                {{totalPrice}}
                <img src="/emktResources/resocurces/img/promotion/miaosha_mobile.png" alt="秒杀进行" height="20px">
              </span>
              <span v-else style="font-weight: bold;font-size: large">{{totalPrice}}</span>
            </span>
          </div>
        </label>
        <section class="gotopay1 gotopay_background" :class="{gotopay_acitvity: totalPrice <= 0}" style="margin-left: 180px" v-if="isSsoFlag === false">
          <span class="gotopay1_button_style" v-if="totalPrice <= 0">保存</span>
          <span class="gotopay1_button_style" style="color: #fff" @click="saveBuyCart()"
                v-else >保存</span>
        </section>
        <section class="gotopay" v-if="isSsoFlag">
          <span class="gotopay_button_style" v-if="totalPrice <= 0" ><img class="img-pay-btn" :src="baseUrl+'go_to_pay_cart_1.png'"></span>
          <span class="gotopay_button_style" style="color: #fff" @click="gotoOrderContentConfirm()"
                v-else ><img class="img-pay-btn" :src="baseUrl+'go_to_pay_cart_2.png'" ></span>
        </section>
        <section class="gotopay gotopay_background" :class="{gotopay_acitvity: totalPrice <= 0}" v-else>
          <span class="gotopay_button_style" v-if="totalPrice <= 0">去审核</span>
          <span class="gotopay_button_style" style="color: #fff" @click="gotoOrderQuotedPriceConfirm()"
                v-else >去审核</span>
        </section>
      </div>
    </footer>
    <div class="modal-overlay modal-overlay-visible" v-if="ifShowShareInstruction" @click="ifShowShareInstruction=false">
      <img src="/emktResources/resocurces/img/promotion/分享指引.png" style="position: absolute;right: 30px;width: 35%;">
    </div>
    <!-- 防止main.js加载过程中，$.toast提示信息导致$.modal消失，因此使用此组件，课题组上线后可替换-->
    <div class="emkt-modal-overlay emkt-modal-overlay-visible" v-if="ifShowBox">
      <div class="emkt-modal-in">
        <div class="emkt-modal-innner"><div>您的好友帮您挑选好了产品<br>是否添加到购物车？</div></div>
        <div class="emkt-modal-buttons ">
          <span class="emkt-modal-button" @click="ifShowBox = false">取消</span>
          <span class="emkt-modal-button" @click="getShareCartContent">添加</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import {ADD_CHECK_LIST, ADD_CART_LIST, DELETE_CART_LIST, REMOVE_FROM_CART_LIST, REMOVE_ALL_CHECKLIST_FROM_CART_LIST} from '../../store/mutation-type.js'
  import merchdata from '../../components/MerchandiseList.vue'
  import newMerchandiseListC from '../finder/components/NewMerchandiseListC.vue'
  import Emkt from '../../emkt.js'
  import md5 from 'js-md5'
  export default {
    mounted () {
      console.log('this.cartList', this.cartList)
      this.getAllChecked()
      this.getSecPromotionInfo()
      this.initNumForSecPromtion()
      if (this.shareCartId) {
        console.log('shareCartId', Emkt.getLocalStorage('shareCartId'))
        this.ifShowBox = true
      }
    },
    created () {
      // this.initVipPLan()
      // 下拉刷新
      $(document).ready(function () {
        $.initPullToRefresh('.pull-to-refresh-content')
      })
      $(document).on('refresh', '.pull-to-refresh-content', () => {
        this.getNonSalesforceShoppingCart()
      })
    },
    components: {
      merchdata, newMerchandiseListC
    },
    data () {
      return {
        recomPproducts: this.emkt.getLocalStorage('EmktAllRecommends'),
        isCheckedAll: false,
        result: 0,
        confirmDelete: false,
        QuoteStatus: this.emkt.getLocalStorage('QuoteStatus'),
        readyToDelIndex: -1,
        isActivity: false,
        totalGoodsNum: 0,
        baseurl: '/emktResources/resocurces/img/merchandise/',
        description: '为你推荐',
        totalPrice: 0,
        isSsoFlag: this.emkt.buyCartIsLocalStorage,
        isCustomFlag: false, // 是否来自定制
        IShints: false,
        baseUrl: '/emktResources/resocurces/img/pay/',
        numOfSecPromotionProducts: {},
        numRequiredForSecPromotion: {},
        secPromotion: Emkt.getLocalStorage('EmktSecPromotion'),
        ifShowShareInstruction: false,
        shareCartId: Emkt.getLocalStorage('shareCartId'),
        ifShowBox: false
      }
    },
    methods: {
      ...mapMutations([
        REMOVE_FROM_CART_LIST, DELETE_CART_LIST, ADD_CART_LIST, ADD_CHECK_LIST, REMOVE_ALL_CHECKLIST_FROM_CART_LIST, 'SET_SECPROMOTION_INFO', 'COMBINE_CART_LIST', 'UPDATE_CART_CONTENT'
      ]),
      shareBuyCartContent () {
        if (!this.checkList || this.checkList.length === 0) {
          $.toast('请勾选分享商品')
          return
        }
        const shareCartContent = {}
        for (let i = 0; i < this.checkList.length; i++) {
          let cartIdName = this.checkList[i].categoryId === 20 ? 'cartid' : 'merchandiseId'
          let shareKey = this.checkList[i][cartIdName]
          shareCartContent[shareKey] = this.cartList.cartContent[shareKey]
        }
        const cartJsonString = JSON.stringify(shareCartContent)
        const cartMD5 = md5(cartJsonString).toUpperCase()
        $.showPreloader('正在生成分享链接')
        this.gcapi('saveShareShoppingCart', {'cartContent': cartJsonString, 'cartMD5': cartMD5}).then(response => {
          $.hidePreloader()
          if (response.body.code === 0) {
            console.log('create shareCartId successfully')
            $.modal({
              afterText: '<div>分享链接生成成功!<br>点击分享给好友</div>',
              buttons: [
                {
                  text: '取消',
                  bold: true,
                  onClick: function () {
                    console.log('cancel')
                  }
                },
                {
                  text: '分享',
                  bold: true,
                  onClick: () => {
                    let shareUrl = Emkt.wxShareUrl
                    shareUrl += '?shareCartId=' + response.body.result
                    $.sign.shareUrl = shareUrl
                    Emkt.wxShare()
                    this.ifShowShareInstruction = true
                  }
                }
              ]
            })
          } else {
            $.showPreloader('保存失败！')
            setTimeout(function () {
              $.hidePreloader()
            }, 1000)
          }
        })
      },
      getShareCartContent () {
        this.ifShowBox = false
        $.showPreloader('查询中')
        this.gcapi('getShareShoppingCart', this.shareCartId).then(res => {
          if (res && res.body.code === 0) {
            let cart
            // DB中无购物车记录或者记录为空{}
            if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
              $.hidePreloader()
              $.toast('分享内容不存在')
            } else {
              cart = res.body.result.cartContent
              const shareCartContent = JSON.parse(cart)
              const currentCartContent = this.cartList.cartContent
              let shareMerchandiseCount = Object.keys(shareCartContent).length
              let existedMerchdiseCount = 0
              // 合并购物车,分享内容置前，若购物车内已存在分享商品，不再重复添加。
              for (let id in currentCartContent) { // insert cartList.cartContent into shareCartContent
                if (id in shareCartContent) {
                  existedMerchdiseCount++
                  if (shareCartContent[id].categoryId !== 20) {
                    shareCartContent[id].productQuantity = currentCartContent[id].productQuantity
                  }
                } else {
                  shareCartContent[id] = currentCartContent[id]
                }
              }
              shareMerchandiseCount -= existedMerchdiseCount
              let remindText = ''
              if (shareMerchandiseCount === 0) {
                remindText = '已有商品不再重复添加'
              } else if (existedMerchdiseCount === 0) {
                remindText = `成功添加${shareMerchandiseCount}个商品`
              } else {
                remindText = `成功添加${shareMerchandiseCount}个商品，已有商品不再重复添加`
              }
              this.UPDATE_CART_CONTENT(JSON.stringify(shareCartContent))
              $.hidePreloader()
              $.toast(remindText)
            }
          }
        })
      },
      initNumForSecPromtion () {
        const numForSecPromtion = {}
        const numRequired = {}
        for (let promotionGuid in this.secPromotionDetailObj) {
          numForSecPromtion[promotionGuid] = 0
          numRequired[promotionGuid] = this.secPromotionDetailObj[promotionGuid].requiredQuantity
        }
        this.numRequiredForSecPromotion = {...numRequired}
        this.numOfSecPromotionProducts = {...numForSecPromtion}
        console.log('numForSecPromtion', this.numRequiredForSecPromotion, this.numOfSecPromotionProducts)
      },
      gotoOrderContentConfirm () {
        if (this.hasLogin === false) {
          $.toast('请登录')
          this.$router.push({name: 'login'})
          return
        }
        this.checkNotAvailableMerchandises()
      },
      checkNotAvailableMerchandises () {
        // 只检查工具类商品的有效性
        const merchandiseIdList = this.checkList
          .filter(mer => mer.categoryId !== Emkt.PRODUCT_TYPE_SERVICE_CONSTANT).map(merchandise => { return merchandise.merchandiseId })
        const serviceProductList = this.checkList.filter(mer => mer.categoryId === Emkt.PRODUCT_TYPE_SERVICE_CONSTANT)
        if (this.checkList.length !== serviceProductList.length && this.checkList.length !== merchandiseIdList.length) {
          this.$weui.alert('工具类和服务类产品不可一起下单')
          return
        }
        this.gcapi('getNotAvailableMerchandiseId', merchandiseIdList).then((res) => {
          if (res.body.code === 0) {
            const notAvailableIds = res.body.result
            if (notAvailableIds.length === 0) {
              this.ifCanGoCheck()
            } else {
              for (let notAvailableId of notAvailableIds) {
                for (let merchandise of this.checkList) {
                  if (notAvailableId === merchandise.merchandiseId) {
                    merchandise.availableFlag = 0
                    merchandise.isChecked = false
                    console.log('find merchandise not availble', merchandise)
                    break
                  }
                }
              }
              $.toast('部分商品已下架，请重新选择')
              return
            }
          }
        })
      },
      ifCanGoCheck () {
        this.IShints = false
        this.transporthints()
        var _this = this
        console.log(this.checkList)
        var cangocheck = true
        const stock = []
        const cust = []
        for (var i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i].categoryId === Emkt.PRODUCT_TYPE_SERVICE_CONSTANT) {
            continue
          }
          if (this.checkList[i].stockOrCustomized === 1) {
            cust.push(this.checkList[i].priceMax)
          } else {
            stock.push(this.checkList[i].priceMax * this.checkList[i].productQuantity)
          }
          if (this.checkList[i].salesLimit > 0) {
            if (this.checkList[i].productQuantity > (this.checkList[i].salesLimit - this.checkList[i].totalSales)) {
              alert('您所购买的商品' + this.checkList[i].merchandiseLabel + '为限购商品，此商品还剩余' + (this.checkList[i].salesLimit - this.checkList[i].totalSales) + '个，请您重新选择')
              cangocheck = false
              break
            }
          }
          if (this.checkList[i].newMerch === undefined && (this.checkList[i].manualFileName.indexOf('腺相关') !== -1 || this.checkList[i].manualFileName.indexOf('神经环路标记病毒') !== -1)) {
            this.$weui.alert('老师：您好！\n' +
                '由于AAV、HSV产品详情内容的调整，您之前添加的该产品，需重新添加至购物车后才能结算下单。\n' +
                '感谢您的支持！')
            cangocheck = false
            break
          }
        }
        var stockprice = 0
        for (var pi in stock) {
          stockprice = stockprice + stock[pi]
        }
        var custprice = 0
        for (var pe in cust) {
          custprice = custprice + cust[pe]
        }
        const now = Date.parse(new Date())
        const lotteryStartDT = new Date('2020/6/24 0:0:0')
        const lotteryEndDT = new Date('2020/6/24 23:59:59')
        var promotiontime = false
        if (now >= Date.parse(lotteryStartDT) && now <= Date.parse(lotteryEndDT)) {
          promotiontime = true
        }
        if (custprice >= 3000 && stockprice >= 2000 && promotiontime) {
          $.modal({
            title: '小提示',
            afterText: '<div>老师，将【现货】与【定制】产品分开下单可以享受更低优惠价哦</div>',
            buttons: [
              {
                text: '继续结算',
                bold: true,
                onClick: function () {
                  if (cangocheck) {
                    if (_this.IShints) {
                      $.modal({
                        title: '小提示',
                        afterText: '<div>当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?</div>',
                        buttons: [
                          {
                            text: '取消',
                            bold: true,
                            onClick: function () {
                              console.log('cancel')
                            }
                          },
                          {
                            text: '确定',
                            bold: true,
                            onClick: function () {
                              _this.checkPromotion()
                            }
                          }
                        ]
                      })
//          $.confirm('当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?',
//            function () {
//              Emkt.setStoreItem('myCoupons', undefined)
//              _this.$router.push({name: 'orderContentConfirm'})
//            },
//            function () {
//              console.log('cancel')
//            })
                    } else {
                      _this.checkPromotion()
//          Emkt.setStoreItem('myCoupons', undefined)
//          _this.$router.push({name: 'orderContentConfirm'})
                    }
                  }
                }
              },
              {
                text: '重新选择',
                bold: true,
                onClick: function () {
                  return
                }
              }
            ]
          })
        } else {
          if (cangocheck) {
            if (_this.IShints) {
              $.modal({
                title: '小提示',
                afterText: '<div>当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?</div>',
                buttons: [
                  {
                    text: '取消',
                    bold: true,
                    onClick: function () {
                      console.log('cancel')
                    }
                  },
                  {
                    text: '确定',
                    bold: true,
                    onClick: function () {
                      _this.checkPromotion()
                    }
                  }
                ]
              })
//          $.confirm('当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?',
//            function () {
//              Emkt.setStoreItem('myCoupons', undefined)
//              _this.$router.push({name: 'orderContentConfirm'})
//            },
//            function () {
//              console.log('cancel')
//            })
            } else {
              _this.checkPromotion()
//          Emkt.setStoreItem('myCoupons', undefined)
//          _this.$router.push({name: 'orderContentConfirm'})
            }
          }
        }
      },
//      getbpromotions (merchdise) {
//        if (merchdise.bpromotions) {
//          var bpromotions = merchdise.bpromotions
//          var r = []
//          var t = []
//          for (var m = 0; m < bpromotions.length; m++) {
//            if (t.indexOf(bpromotions[m].type) === -1) {
//              r.push(bpromotions[m])
//              t.push(bpromotions[m].type)
//              // console.log(m + ' ' + bpromotions[m].type)
//            }
//          }
//          console.log(1)
//          console.log(r)
//          return r
//        }
//      },
      gotoOrderQuotedPriceConfirm () {
        // if (this.sessionInfo.customerInfo) {
        //   var CustomerPlanParams = {
        //     'CustomerNo': this.sessionInfo.customerInfo.customerNo
        //   }
        //   this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
        //     var VipPlanList = response.body.result
        //     Emkt.setLocalStorage('VipPlanList', VipPlanList)
        //   })
        // }
        let cango = true
        for (let i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i].newMerch === undefined && (this.checkList[i].manualFileName.indexOf('腺相关') !== -1 || this.checkList[i].productName.indexOf('神经环路标记病毒') !== -1)) {
            this.$weui.alert('老师：您好！\n' +
                '由于AAV、HSV产品详情内容的调整，您之前添加的该产品，需重新添加至购物车后才能结算下单。\n' +
                '感谢您的支持！')
            cango = false
            break
          }
        }
        if (cango) {
          Emkt.setStoreItem('myCoupons', undefined)
          this.$router.push({name: 'orderContentConfirm'})
        }
      },
      getChecked (product) {
        // if (product.isChecked) {
        //   product.isChecked = false
        // } else {
        //   product.isChecked = true
        // }
        console.log('getChecked' + product.isChecked)
        this.getAllChecked()
      },
      saveBuyCart () {
        let list = this.checkList
        var savelist = {}
        let i
        for (i = 0; i < list.length; i++) {
          for (var item in this.cartList.cartContent) {
            if (item === list[i].merchandiseId) {
              savelist[list[i].merchandiseId] = list[i]
            }
          }
        }
        const saveContent = JSON.stringify(savelist) === '{}' ? null : JSON.stringify(savelist)
        this.gcapi('saveShoppingCart', saveContent).then(function (response) {
          if (response.body.code === 0) {
            $.showPreloader('保存成功！')
            setTimeout(function () {
              $.hidePreloader()
            }, 1000)
          } else {
            $.showPreloader('保存失败！')
            setTimeout(function () {
              $.hidePreloader()
            }, 1000)
          }
        })
        // this.REMOVE_ALL_CHECKLIST_FROM_CART_LIST()
      },
      changeQuantity (good, val) {
        if (good.productQuantity === void 0) {
          this.$set(good, 'productQuantity', 1)
        }
        if (val === 1) {
          Emkt.customerBehaviours.cart.addCount.push({'time': Date.parse(new Date()), 'target': good.merchandiseId, 'type': Emkt.customerBehaviourType.addCount})
          this.ADD_CART_LIST(good)
        } else if (val === -1) {
          Emkt.customerBehaviours.cart.minusCount.push({'time': Date.parse(new Date()), 'target': good.merchandiseId, 'type': Emkt.customerBehaviourType.minusCount})
          if (good.productQuantity === 1 && val === -1) {
            this.removeProduct(good, good.merchandiseId)
          } else {
            this.DELETE_CART_LIST(good)
          }
        }
        this.getAllChecked()
      },
      initVipPLan () {
        Emkt.setLocalStorage('VipPlanList', null)
        if (this.sessionInfo.customerInfo) {
          var CustomerPlanParams = {
            'CustomerNo': this.sessionInfo.customerInfo.customerNo
          }
          this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
            var VipPlanList = response.body.result
            Emkt.setLocalStorage('VipPlanList', VipPlanList)
          })
        }
      },
      checkedAll () {
        var self = this
        if (self.isCheckedAll) {
          self.isCheckedAll = false
        } else {
          self.isCheckedAll = true
        }
        console.log('isCheckedAll ' + self.isCheckedAll)
        this.products.forEach(item => {
          item.isChecked = self.isCheckedAll
        })
        this.getAllChecked()
      },
      removeProduct (product, merchandiseId) {
        var _this = this
        $.confirm('您确定删除此商品吗？',
        function () {
          $.showIndicator()
          setTimeout(function () {
            $.hideIndicator()
          }, 300)
//          _this.products.splice(index, 1)
          if (product.categoryId === 20) {
            let id = product.cartid
            _this.REMOVE_FROM_CART_LIST(id)
          } else if (product.categoryId === Emkt.PRODUCT_TYPE_SERVICE_CONSTANT) {
            _this.REMOVE_FROM_CART_LIST(product.cartid)
          } else {
            _this.REMOVE_FROM_CART_LIST(merchandiseId)
          }
          _this.getAllChecked()
          _this.remindSaveBuyCart()
          Emkt.customerBehaviours.cart.delete.push({'time': Date.parse(new Date()), 'target': merchandiseId, 'type': Emkt.customerBehaviourType.delete})
        },
        function () {
          console.log('cancel')
          Emkt.customerBehaviours.cart.delete.push({'time': Date.parse(new Date()), 'target': merchandiseId, 'type': Emkt.customerBehaviourType.cancel})
        })
      },
      getAllChecked () {
        let sum = 0
        let checks = []
        let isAllCheckeds = true
        // 初始化参与秒杀的商品总数
        const initObj = {}
        for (let guid in this.numOfSecPromotionProducts) {
          initObj[guid] = 0
        }
        this.numOfSecPromotionProducts = {...initObj}
        // 统计参与秒杀的商品总数
        this.products.forEach(item => {
          if (item.isChecked) {
            if (item.promotions && item.promotions[0] && item.promotions[0].type === 6 && this.secFlag === 1) {
              this.numOfSecPromotionProducts[item.promotions[0].promotionGuid] += item.productQuantity
            }
          }
        })
        this.products.forEach(item => {
          if (item.isChecked) {
            if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
              sum += item.priceMax * item.productQuantity
            //  n件享受秒杀折扣
            } else if (item.promotions && item.promotions[0] && item.promotions[0].type === 6 && this.secFlag === 1 && this.numOfSecPromotionProducts[item.promotions[0].promotionGuid] >= this.numRequiredForSecPromotion[item.promotions[0].promotionGuid]) {
              sum += item.priceMax * item.productQuantity * (1 - this.secPromotionDetailObj[item.promotions[0].promotionGuid].seckilltRatio)
            } else {
              sum += item.priceMin * item.productQuantity
            }
            checks.push(item)
          } else {
            isAllCheckeds = false
          }
        })
        this.isCheckedAll = isAllCheckeds
        this.ADD_CHECK_LIST(checks)
        sum = sum.toFixed(2)
        this.totalPrice = sum
      },
      remindSaveBuyCart () {  // 当购物车为空时，提醒sf业务员保存购物车
        if (this.isSFFlag === false) {
          return
        }
        if (this.products && this.products.length === 0) {
          $.confirm('您是否需要清空数据库购物车？',
            () => {
              $.toast('保存中')
              this.saveBuyCart()
            },
            () => {
            })
        }
      },
      checkCust () {
        // 定制商品不支持添加数量
        let flag = false
        let cart = this.cartList.cartContent
        if (cart) {
          let cur = cart.Customized01
          if (cur) {
            flag = true
            $.toast('定制商品不支持修改数量')
          }
        }
//        this.isCustomFlag = flag
        return flag
      },
      goToDetail (product) {
        Emkt.behaviour.time = Date.parse(new Date())
        Emkt.behaviour.target = product.merchandiseId
        Emkt.behaviour.type = Emkt.customerBehaviourType.click
        Emkt.customerBehaviours.cart.goToDetail = Emkt.behaviour
        let id = product.categoryId
        if (id === 10) {
          this.$router.push({name: 'custDetail', query: { custom: product.merchandiseId }})
        } else {
//          this.$router.push({name: 'merchandises', query: { id: product.merchandiseId }})
          this.$router.replace({name: 'FinderOrderDeail', query: {merchandises: JSON.stringify(product), id: 1}})
//          this.$router.push({name: 'finderMerchandises', params: {merchandises: product}})
        }
      },
      transporthints () {
        for (var i in this.checkList) {
          for (var j in this.checkList[i]._attributesList) {
            if (this.checkList[i]._attributesList[j].columnName === 'TransportCondition' && this.checkList[i]._attributesList[j].value === 0) {
              this.IShints = true
              break
            }
          }
        }
      },
      checkPromotion () {
        var allpromotion = []
//        if (this.sessionInfo.customerInfo) {
//          var CustomerPlanParams = {
//            'CustomerNo': this.sessionInfo.customerInfo.customerNo
//          }
//          this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
//            var VipPlanList = response.body.result
//            Emkt.setLocalStorage('VipPlanList', VipPlanList)
//          })
//        }

        for (var i in this.checkList) {
          for (var j in this.checkList[i]._attributesList) {
            if (this.checkList[i]._attributesList[j].columnName === 'TransportCondition' && this.checkList[i]._attributesList[j].value === 0) {
              this.IShints = true
              break
            }
          }
          var promotion = []
          for (var m in this.checkList[i].showpromotion) {
            if (this.checkList[i].showpromotion[m].type === 1 && this.checkList[i].showpromotion[m].requiredMoney > 0) {
              allpromotion.push(this.checkList[i].showpromotion[m])
              promotion.push(this.checkList[i].showpromotion[m])
            }
          }
          this.checkList[i].allpromotion = promotion
        }
        // var obj = {}
        // allpromotion = allpromotion.reduce(function (item, next) {
        //   obj[next.promotionGuid] ? '' : obj[next.promotionGuid] = true && item.push(next)
        //   return item
        // }, [])
        var _this = this
        // if (allpromotion.length > 0) {
        //   for (var n in allpromotion) {
        //     var lackmoney = allpromotion[n].requiredMoney
        //     for (var k in _this.checkList) {
        //       for (var l in _this.checkList[k].allpromotion) {
        //         if (_this.checkList[k].allpromotion[l].promotionGuid === allpromotion[n].promotionGuid) {
        //           lackmoney = lackmoney - _this.checkList[k].priceMin * _this.checkList[k].productQuantity
        //         }
        //       }
        //     }
        //     allpromotion[n].lackmoney = lackmoney
        //   }
        //   allpromotion.sort(function (a, b) {
        //     return a.lackmoney - b.lackmoney
        //   })
          // for (var p in allpromotion) {
            // if (allpromotion[p].lackmoney > 0 && allpromotion[p].lackmoney < allpromotion[p].requiredMoney) {
              // $.modal({
              //   title: '小提示',
              //   afterText: '<div>您还差' + allpromotion[p].lackmoney + '元即可参与' + allpromotion[p].name + '活动</div>',
              //   buttons: [
              //     {
              //       text: '暂不结算',
              //       bold: true,
              //       onClick: function () {
              //       }
              //     },
              //     {
              //       text: '继续结算',
              //       bold: true,
              //       onClick: function () {
              //         Emkt.setStoreItem('myCoupons', undefined)
              //         _this.$router.push({name: 'orderContentConfirm'})
              //       }
              //     }
              //   ]
              // })
            //   break
            // } else {
            //   Emkt.setStoreItem('myCoupons', undefined)
            //   _this.$router.push({name: 'orderContentConfirm'})
            // }
          // }
        Emkt.setStoreItem('myCoupons', undefined)
        // _this.$router.push({name: 'orderContentConfirm'})
        if (_this.sessionInfo.customerInfo.ssoFlag === 1) {
          _this.$router.push({name: 'orderContentConfirm'})
        } else {
          _this.$router.push({name: 'WeappOrderContentConfirmation'})
        }
      },
      showSecPromotionInfo (product) {
        if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
          return false
        }
        // n 件参加秒杀
        if (product.promotions) {
          const guid = product.promotions[0] && product.promotions[0].promotionGuid
          return product.isChecked && product.promotions[0] && product.promotions[0].type === 6 && this.secFlag === 1 && this.numOfSecPromotionProducts[guid] >= this.numRequiredForSecPromotion[guid]
        }
        return false
      },
      secPromotionProductIncluded () {
        if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
          return false
        }
        // n 件参加秒杀
        for (let guid in this.secPromotionDetailObj) {
          if (this.numOfSecPromotionProducts[guid] && this.numOfSecPromotionProducts[guid] >= this.numRequiredForSecPromotion[guid]) return true
        }
        return false
      },
      getSecPromotionInfo () {
        let info = {}
        if (this.secPromotion === '' || this.secPromotion === undefined) {
          return
        }
        info.startDT = this.secPromotion.startDT
        info.endDT = this.secPromotion.endDT
        info.promotionGuid = this.secPromotion.promotionGuid
        info.now = Date.parse(new Date())
        this.gcapi('getSeckillPromotion', info.promotionGuid)
          .then((response) => {
            const result = response.body.result
            Object.assign(info, result)
            this.SET_SECPROMOTION_INFO(info)
            console.log('secinfo', this.secInfo)
            console.log('secflag', this.secFlag)
          })
      },
      getNonSalesforceShoppingCart () {
        if (this.isSFFlag === true || this.hasLogin === false) {
          $.pullToRefreshDone('.pull-to-refresh-content') // done
          return
        }
        const customerNo = this.sessionInfo.customerInfo.customerNo
        console.log('getNonSalesforceShoppingCart', customerNo)
        this.gcapi('getNonSalesforceShoppingCart', customerNo).then(res => {
          if (res && res.body.code === 0) {
            let cart
            // DB中无购物车记录或者记录为空{}
            if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
              cart = '{}'
            } else {
              cart = res.body.result.cartContent
            }
            this.UPDATE_CART_CONTENT(cart)
          }
          // alert('refresh finish')
          $.pullToRefreshDone('.pull-to-refresh-content') // done
        })
      },
      secPromotionPrice (product) {
        const guid = product.promotions[0].promotionGuid
        const seckilltRatio = this.secPromotionDetailObj[guid].seckilltRatio
        return ((1 - seckilltRatio) * product.priceMax) && ((1 - seckilltRatio) * product.priceMax).toFixed(2)
      },
      secPromotionType (product) {
        const guid = product.promotions[0].promotionGuid
        return this.secPromotionDetailObj[guid].seckillType
      },
      filteredShowPromotions (merchandise) {
        if (merchandise.promotions && merchandise.promotions.length > 0 && merchandise.amplification === 0) {
          return merchandise.promotions.filter(pro => pro.requiredCustomers === 0 && pro.name && pro.type !== 0)
        }
        if (merchandise.bpromotions && merchandise.bpromotions.length > 0 && merchandise.amplification === 0) {
          return merchandise.bpromotions.filter(pro => pro.requiredCustomers === 0 && pro.name && pro.type !== 0)
        }
        return []
      }
    },
    watch: {
//      'isCustomFlag': 'checkCust'
      'isCheckedAll': function (val) {
        console.log('watch ischeckedALl', val)
      }
    },
    computed: {
      ...mapState([
        'cartList', 'sessionInfo', 'checkList', 'secInfo', 'secPromotionDetailObj'
      ]),
      ...mapGetters([
        'secFlag', 'hasLogin', 'isSFFlag'
      ]),
      products () {
        let products = []
        var self = this
        Object.keys(this.cartList.cartContent).forEach(function (item) {
          products.push(self.cartList.cartContent[item])
        })
        return products
      },
      getTotalGoodsNum () {
//        this.checkCust()
        var self = this
        let sum = 0
        Object.keys(this.cartList.cartContent).forEach(function (item) {
          sum += self.cartList.cartContent[item].productQuantity
        })
        this.getAllChecked()
        return sum
      },
      hasSharePermission () {
        // sf不显示分享链接
        return this.hasLogin && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag !== 1
      }
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .emkt-modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10600;
    width: 100%;
    height: 100%;
    visibility: hidden;
    background: rgba(0,0,0,.4);
    transition-duration: .4s;
  }
  .emkt-modal-overlay-visible {
    visibility: visible;
    opacity: 1;
  }
  .emkt-modal-in {
    font-family: "Helvetica Neue",Helvetica,sans-serif;
    font-size: .85rem;
    line-height: 1.5;
    visibility: visible;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    left: 50%;
    z-index: 11000;
    width: 13.5rem;
    margin-top: 0;
    margin-left: -6.75rem;
    color: #3d4145;
    text-align: center;
    border-radius: .35rem;
    transition-property: transform,opacity;
    opacity: 1;
    transition-duration: .4s;
    transform: translate3d(0,0,0) scale(1);
    position: absolute;
    display: block;
    top: 30%;
  }
  .emkt-modal-innner {
    position: relative;
    padding: .75rem;
    background: #e8e8e8;
    border-bottom: 1px solid #b5b5b5;
    border-radius: .35rem .35rem 0 0;
  }
  .emkt-modal-buttons {
    display: flex;
    height: 2.2rem;
    overflow: hidden;
    justify-content: center;
  }
  .emkt-modal-button {
    position: relative;
    display: block;
    width: 100%;
    height: 2.2rem;
    box-sizing: border-box;
    padding: 0 .25rem;
    overflow: hidden;
    font-size: .85rem;
    line-height: 2.2rem;
    color: #0894ec;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    background: #e8e8e8;
    border-right: 1px solid #b5b5b5;
    -webkit-box-flex: 1;
    border-radius: 0 0 0 .35rem;
    font-weight: 500;
  }
  .emkt-modal-button:last-child {
    border-bottom: 0;
    border-left: 0;
    border-radius: 0 0 .35rem 0;
  }
  .gotopay{
    position: absolute;
    right: 0;
    color: #fff;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -36px;
    width: 80px;
    height: 54px;}
  .gotopay1{
    position: absolute;
    color: #fff;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -39px;
    width: 70px;
    height: 54px;}
  .gotopay_button_style{
  @include sc(.7rem, #045aa5);
    font-weight: bold;
  }
  .gotopay_background {
    background-color: #045aa5;
  }
  .gotopay_acitvity{
    background-color: grey;
  }

  .img-pay-btn {
    width: 90px;
    height: 54px;
  }

  .checkbox-el {
    display: inline-block;
    text-align: left;
  }


  /*搜索内容区*/
  .item-inner {
    display: block;
  }
  .item-title {
    font-size: 0.6rem;
  }
  item-text {
    margin-top: 0.3rem;
  }
  .sub-span {
    font-size: 0.5rem;
    color: white;
    background-color: #00469A;padding: 0.1rem;border-radius:.25rem;
  }

  .workdays {
    display: inherit;font-size: .5rem;line-height: 0px;height: 0.85rem;border-radius:.45rem;border:1px solid #1D66E1;color:#1D66E1
  }
  button.share-link[disabled] {
    background-color: #929292;
  }
  .share-link {
    display: inherit;
    font-size: .5rem;
    border-radius:.5rem;
    color:#fff;
    background-color: #013C8E;
    position: absolute;
    top: 0.6rem;
    z-index: 2;
    border: none;
    padding: 3px 10px;
  }
  .radiuscolor {
    background-color: #E6E6E6;border-radius:.25rem;
  }
</style>



// WEBPACK FOOTER //
// Cart.vue?1fac673b